<template>
    <Head>
        <title>Composition Report | NutriStudents K-12</title>
        <meta name="description" content="Composition Report" />
    </Head>
    <default-layout>
        <BreadcrumLayout>
            <U>Tools</U>
        </BreadcrumLayout>
        <PageTitleLayout>
            <div class="w-full mb-4 lg:mb-0">
                <h1 class="text-2xl font-bold heading-color xl:text-4xl">
                    Composition Report
                </h1>
            </div>
            <div class="flex flex-wrap items-center justify-end w-full lg:flex-nowrap"></div>
        </PageTitleLayout>

        <div class="items-end justify-between w-full px-5 pt-5 mb-5 xl:flex xl:px-10 xl:pt-10 lg:mb-10">
            <div class="flex-wrap items-end w-full -mx-3 sm:flex">

                <div class="w-full px-3 mb-4 focus:outline-none lg:w-80 sm:w-1/2 xl:mt-0 lg:mb-0"
                    :class="{ 'disable_search_inputs': disabledRecipeSearch }">
                    <label for="" class="text-sm font-bold uppercase text-black-800">Recipe</label>

                    <div class="relative w-full mt-2 mr-3 focus:outline-none sm:mt-0">
                        <div class="relative w-full">
                            <input
                                class="w-full h-10 px-3 pr-10 text-sm bg-white border-2 border-gray-300 rounded-lg focus:outline-none"
                                type="text" id="mc_option_recipe_search" v-model="searchRecipeName" @input="
                                    recipe_search_method($event)" placeholder="Search Recipe..."
                                :disabled="disabledRecipeSearch" />
                            <span v-if="!emptyRecipeSearchBox" class="
                        flex
                        items-center
                        justify-center
                        bg-transparent
                        text-[#385f9f]
                        opacity-100
                        h-6
                        w-6
                        text-base
                        outline-none
                        focus:outline-none
                        cursor-pointer
                        absolute
                        top-[3px]
                        right-2.5
                        font-extrabold
                        mt-1
                      " @click="emptyRecipeSearchBoxValue">x</span>
                            <div class="
                        absolute
                        z-20
                        bg-white
                        max-w-2xl
                        overflow-x-auto
                        w-full
                        max-h-[150px]
                      ">
                                <div v-if="showRecipeSearchBoxShow" v-for="(searched_recipe, index) in searched_recipes"
                                    class="px-3 py-1 cursor-pointer hover:bg-gray-100"
                                    @click="addRecipeToForm(searched_recipe, index)">
                                    {{ searched_recipe.custom_id }} -
                                    {{ searched_recipe.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="w-full px-3 mb-4 focus:outline-none lg:w-80 sm:w-1/2 xl:mt-0 lg:mb-0"
                    :class="{ 'disable_search_inputs': disabledProductSearch }">
                    <label for="" class="text-sm font-bold uppercase text-black-800">Products</label>

                    <div class="relative w-full mt-2 mr-3 focus:outline-none sm:mt-0">
                        <div class="relative w-full">
                            <input
                                class="w-full h-10 px-3 pr-10 text-sm bg-white border-2 border-gray-300 rounded-lg focus:outline-none"
                                type="text" id="mc_option_recipe_search" v-model="searchProductName" @input="
                                    product_search_method(
                                        $event
                                    )
                                    " placeholder="Search Product..." :disabled="disabledProductSearch" />
                            <span v-if="searchProductName != ''" class="
                        flex
                        items-center
                        justify-center
                        bg-transparent
                        text-[#385f9f]
                        opacity-100
                        h-6
                        w-6
                        text-base
                        outline-none
                        focus:outline-none
                        cursor-pointer
                        absolute
                        top-[3px]
                        right-2.5
                        font-extrabold
                        mt-1
                      " @click="cancelProductSearchValue">x</span>
                            <div class="absolute z-20 w-full max-w-2xl overflow-x-auto bg-white max-h-150">
                                <div v-if="showProductSearchBoxShow" v-for="(searched_product, index) in searched_products"
                                    class="px-3 py-1 cursor-pointer hover:bg-gray-100"
                                    @click="addProductToForm(searched_product, index)">
                                    {{ searched_product.custom_id }} -
                                    {{ searched_product.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <a href="javascript:void(0)" @click="resetSearch" class="flex items-center"><img
                        :src="$page.props.asset_url + '/images/clear-filter.png'" /></a>

                <a target="_blank"
                    :href="'/download-nutrient-composition-report?data=' + encodeURIComponent(JSON.stringify(searchResults)) + '&recipe=' + searchRecipeId"
                    v-if="searchResults.length > 0">
                    <button v-if="searchResults.length > 0"
                        class="button-color w-40 text-white font-bold py-1.5 rounded px-1.5 md:mt-0 mt-4 ml-4">Download</button>
                </a>

                <a target="_blank"
                    :href="'/download-nutrient-composition-report-recipe?data=' + encodeURIComponent(JSON.stringify(getIds(form.recipes))) + '&recipe=' + searchRecipeId"
                    v-if="form.recipes.length > 0">
                    <button v-if="form.recipes.length > 0"
                        class="button-color w-40 text-white font-bold py-1.5 rounded px-1.5 md:mt-0 mt-4 ml-4">Download</button>
                </a>
            </div>
        </div>

        <TableIndexLayout>
            <div class="mb-0 -my-2">
                <div class="inline-block w-full px-5 py-2 pb-0 align-middle xl:px-10">
                    <div class="mb-10 overflow-auto shadow">
                        <table class="min-w-full">
                            <thead class="header-bg-color">
                                <tr v-if="form.products.length > 0">
                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        PRODUCT NAME
                                    </th>

                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        SOURCE
                                    </th>

                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        MANUFACTURER
                                    </th>

                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        CN#
                                    </th>

                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        MFG#
                                    </th>


                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        CATEGORY
                                    </th>

                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        SUB CATEGORY
                                    </th>
                                </tr>


                                <tr v-if="form.recipes.length > 0">
                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        RECIPE NAME
                                    </th>

                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                        SOURCE
                                    </th>
                                    <th scope="col"
                                        class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">

                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="form.products.length < 1 && form.recipes.length < 1" class="bg-white">
                                    <td class="px-6 py-4 text-base text-center whitespace-nowrap text-color" colspan="7">
                                        Please Search Recipe/Prodcuts</td>
                                </tr>
                                <tr v-for="(product, index) in form.products"
                                    :class="{ 'bg-white': index % 2 == 0, 'tr-background-color': index % 2 != 0 }">
                                    <td class="px-6 py-4">{{ product.name }}</td>
                                    <td class="px-6 py-4">{{ product.tenant_name }}</td>
                                    <td class="px-6 py-4">{{ product.manufacturer }}</td>
                                    <td class="px-6 py-4">{{ product.cn_code }}</td>
                                    <td class="px-6 py-4">{{ product.manufacturer_sku }}</td>
                                    <td class="px-6 py-4">{{ product.category_name[0] }}</td>
                                    <td class="px-6 py-4">{{ product.sub_category_name[0] }}</td>
                                </tr>
                                <tr v-for="(recipe, index) in form.recipes"
                                    :class="{ 'bg-white': index % 2 == 0, 'tr-background-color': index % 2 != 0 }">
                                    <td class="px-6 py-4">{{ recipe.show_name }}</td>
                                    <td class="px-6 py-4">{{ recipe.tenant_name }}</td>
                                    <td class="flex gap-2 px-6 py-4 text-xl font-extrabold whitespace-nowrap id-color">

                                        <a :href="route('recipes-edit', { id: recipe.id })" class="" target="_blank">
                                            <i class="fa fa-external-link" aria-hidden="true"></i>
                                        </a>

                                        <button type="button" @click="getRecipeProducts(recipe.id)" class="">
                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" @click="removeRecipe(recipe.id, index)" class="">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </TableIndexLayout>

        <jet-dialog-modal :show="showRecipeProduct">
            <template #title>
                <div class="flex items-center justify-between">Products</div>
            </template>

            <template #content>
                <div class="w-full overflow-auto">


                    <table class="w-full">
                        <thead class="header-bg-color">
                            <tr>
                                <th scope="col"
                                    class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                    PRODUCT NAME
                                </th>

                                <th scope="col"
                                    class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                    SOURCE
                                </th>

                                <th scope="col"
                                    class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                    MANUFACTURER
                                </th>

                                <th scope="col"
                                    class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                    CN#
                                </th>

                                <th scope="col"
                                    class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                    MFG#
                                </th>


                                <th scope="col"
                                    class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                    CATEGORY
                                </th>

                                <th scope="col"
                                    class="relative px-6 py-3 text-base font-bold tracking-wider text-left uppercase id_arrow text-black-800">
                                    SUB CATEGORY
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="recipe_products.length < 1" class="bg-white">
                                <td class="px-6 py-4 text-base text-center whitespace-nowrap text-color" colspan="7">
                                    No Prodcuts Found</td>
                            </tr>
                            <tr v-for="(product, index) in recipe_products"
                                :class="{ 'bg-white': index % 2 == 0, 'tr-background-color': index % 2 != 0 }">
                                <td class="px-6 py-4">{{ product.name }}</td>
                                <td class="px-6 py-4">{{ product.tenant_name }}</td>
                                <td class="px-6 py-4">{{ product.manufacturer }}</td>
                                <td class="px-6 py-4">{{ product.cn_code }}</td>
                                <td class="px-6 py-4">{{ product.manufacturer_sku }}</td>
                                <td class="px-6 py-4">{{ product.category_name[0] }}</td>
                                <td class="px-6 py-4">{{ product.sub_category_name[0] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template #footer>
                <jet-secondary-button @click="showRecipeProduct = false" class="cursor-pointer">Close</jet-secondary-button>
            </template>
        </jet-dialog-modal>
    </default-layout>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import Paginate from "@/Pages/Partials/Paginate";
import Option from "../MenuCycle/Option.vue";
// import DateRangePicker from 'daterange-picker-vue3';
// import 'daterange-picker-vue3/dist/daterange-picker-vue3.css'
import JetDialogModal from "@/Jetstream/DialogModal";
import moment from "moment";
import DatePicker from "../../components/DatePicker.vue";

export default {
    props: ["recipe"],
    components: {
        DefaultLayout,
        BreadcrumLayout,
        PageTitleLayout,
        TableFilterLayout,
        TableIndexLayout,
        Paginate,
        DatePicker,
        JetDialogModal
    },
    data() {
        return {
            // show: {
            //     calendar: false,
            // },
            showRecipeProduct: false,
            recipe_products: [],
            debounce: null,
            searched_recipes: [],
            searched_products: [],
            showSearchProductsBox: false,

            recipes: [],
            searchResults: [],
            // offerings: [],
            // options: {},
            // exportRecipe: [],
            // exportRecipeSearced: [],
            // exportAssembly: [],
            // recipeStudentCount: [],
            // recipeCurrentStudentCount: [],
            // searchByName: "",
            // siteName: [],
            searchProductName: "",
            showProductSearchBoxShow: false,
            showRecipeSearchBoxShow: false,
            disabledRecipeSearch: false,
            disabledProductSearch: false,
            // searchRecipeName: this.recipe.name,
            // searchRecipeId: this.recipe.id,
            emptyRecipeSearchBox: true,
            form: {
                // site: "",
                // offer: "",
                // type: "",
                // day_id: [],
                products: [],
                recipes: [],
            },
        };
    },

    mounted() {
        // this.selectRecipesIdToAddProducts(this.recipe);
        if (this.recipe != '') {
            this.form.recipes.push(this.recipe);
            // this.showRecipeSearchBoxShow = true,
            //     this.disabledProductSearch = true;
            // this.emptyRecipeSearchBox = false;
        }

    },

    methods: {

        getRecipeProducts(recipeId) {
            this.showRecipeProduct = true;
            this.recipe_products = [];
            axios.post("/recipe-products", {
                recipeId: recipeId,
            })
                .then((response) => {

                    if (response.data) {
                        this.recipe_products = response.data;
                    }
                    if (this.recipe_products.length < 1) {
                        this.$toast.clear();
                        this.$toast.error("Error:No products in this recipe");
                    }
                })
                .catch((error) => console.error(error));

        },

        resetSearch() {
            this.emptyRecipeSearchBox = true;
            this.searchRecipeName = "";
            this.searchRecipeId = "";
            this.searchProductName = "";
            this.form.products = [];
            this.form.recipes = [];
            this.searchResults = [];
            this.cancelProductSearchValue();
            this.cancelRecipeSearchValue();
            this.disabledRecipeSearch = false;
            this.disabledProductSearch = false;
        },

        selectRecipesIdToAddProducts(searched_recipe) {
            console.log('searched_recipe searched_recipe', searched_recipe);
            this.searchRecipeName = searched_recipe.name;
            this.searchRecipeId = searched_recipe.id;
            if (searched_recipe != '') {
                axios.post("/products-search-by-recipe-for-nutrient-composition-report", {
                    recipeId: searched_recipe.id,
                })
                    .then((response) => {
                        // console.log('Response', response);
                        this.form.products = [];
                        this.searchResults = [];
                        if (response.data.ingredients) {
                            response.data.ingredients.forEach((ingredient) => {
                                if (ingredient.prefer_product) {
                                    this.addProductToForm(ingredient.prefer_product);
                                    // ingredient.prefer_product.forEach((product) => {
                                    //     this.addProductToForm(product);
                                    // });
                                }
                            });
                        }

                        if (this.form.products.length < 1) {
                            this.$toast.clear();
                            this.$toast.error("Error:No products in this recipe");
                        }
                        this.cancelRecipeSearchValue();
                    })
                    .catch((error) => console.error(error));
            }
        },

        addRecipeToForm(searched_recipe, index) {
            // this.form.products = [];
            this.searchResults = [];
            console.log("searched_recipe", searched_recipe);
            if (!this.form.recipes.some(item => item.id === searched_recipe.id)) {
                this.form.recipes.push(searched_recipe);
            }

            this.searched_recipes.splice(index, 1);
        },

        removeRecipe(id, index) {
            this.form.recipes.splice(index, 1);
            // this.searchResults = this.searchResults.filter(item => item.id !== id);
            this.searchResults = [];
        },

        cancelProductSearchValue() {
            this.searchProductName = "";
            this.showProductSearchBoxShow = false;
        },

        emptyRecipeSearchBoxValue() {
            this.searchRecipeName = "";
            this.searchRecipeId = "";
            this.form.products = [];
            this.searchResults = [];
            this.emptyRecipeSearchBox = true;
            this.showRecipeSearchBoxShow = false;

        },

        cancelRecipeSearchValue() {
            this.showRecipeSearchBoxShow = false;
        },

        addProductToForm(addProduct, index) {
            // console.log("add product ffffffffffffffff", addProduct);
            const productExists = this.form.products.some(product => product.id === addProduct.id);
            if (!productExists) {
                // this.cancelProductSearchValue();
                this.cancelRecipeSearchValue();
                this.form.products.push(addProduct);
                this.searchResults.push({
                    id: addProduct.id
                });
                this.searched_products.splice(index, 1);
            } else {
                this.$toast.clear();
                this.$toast.error("Error:Product already exists");
                console.log("Product already exists in the form:", addProduct);
            }

        },

        product_search_method(e) {
            this.disabledRecipeSearch = true;
            this.cancelRecipeSearchValue();
            let $this = this;
            let search_term = e.target.value;
            this.$toast.clear();
            clearTimeout(this.debounce)
            if (search_term == "") {
                this.searched_products = [];
                this.$toast.error("Error: Search value required!");

            } else {
                this.debounce = setTimeout(() => {
                    axios
                        .post("/nutrient-composition-report-products-search", {
                            term: search_term,
                            'exclude_ids': this.getAddedProductIdsFromForm()
                        })
                        .then((response) => {
                            // console.log('products search', response);
                            this.showProductSearchBoxShow = true;
                            $this.searched_products = [];
                            $this.searched_products = response.data;
                        })
                        .catch((error) => console.error(error));
                }, 900);

            }
        },

        getAddedProductIdsFromForm() {
            return this.form.products.map((product) => product.id);
        },

        selectRecipesIdToSearchProducts(searchRecipie) {
            console.log(searchRecipie);
        },

        recipe_search_method(e) {
            this.disabledProductSearch = true;
            this.emptyRecipeSearchBox = false;
            this.cancelProductSearchValue();
            let $this = this;
            let search_term = e.target.value;
            this.$toast.clear();
            clearTimeout(this.debounce)
            if (search_term == "") {
                this.searched_recipes = [];
                this.$toast.error("Error: Search value required!");
            } else {
                this.debounce = setTimeout(() => {
                    axios
                        .post("/nutrient-composition-report-recipes-search", {
                            term: search_term,
                            'exclude_ids': this.getIds()
                        })
                        .then((response) => {
                            // console.log('products search', response);
                            this.showRecipeSearchBoxShow = true;
                            $this.searched_recipes = [];
                            $this.searched_recipes = response.data;
                        })
                        .catch((error) => console.error(error));
                }, 900);

            }
        },
        getIds() {
            return this.form.recipes.map((recipe) => recipe.id);
        }



    },
};
</script>

<style>
.id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 17px;
    left: 43px;
    padding-left: 7px;
    color: #219fd5;
}

.id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219fd5;
    padding-left: 7px;
    position: absolute;
    top: 17px;
    left: 43px;
}

.max-height-screen {
    max-height: calc(100vh - 380px);
}

.trim_text {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
}

.tooltip {
    display: inline-block;
    position: relative;
    text-align: left;
}

.tooltip .top {
    width: 250px;
    top: 50%;
    left: 100%;
    margin-left: 20px;
    transform: translate(0, -50%);
    padding: 5px 10px;
    color: #444444;
    background-color: #eeeeee;
    font-weight: normal;
    font-size: 14px;
    border-radius: 5px;
    position: absolute;
    z-index: 99999999;
    box-sizing: border-box;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
    display: none;
    white-space: normal;
}

.tooltip:hover .top {
    display: block;
}

.tooltip .top i {
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -12px;
    width: 12px;
    height: 24px;
    overflow: hidden;
}

.tooltip .top i::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    left: 0;
    top: 50%;
    transform: translate(50%, -50%) rotate(-45deg);
    background-color: #eeeeee;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

.cart-color {
    color: #f7a53a;
}

.recipe_name_list {
    display: none;
}

.onhover:hover .recipe_name_list {
    display: block;
}

table.min-w-full tr:last-child .recipe_name_list {
    top: auto;
    bottom: 32px;
}

.vue-daterange-picker {
    width: 100%;
    display: block !important;
}

.vue-daterange-picker .form-control.reportrange-text {
    --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
        var(--tw-shadow);
    border-radius: 0.5rem;
    --tw-border-opacity: 1;
    border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}

.disable_search_inputs {
    opacity: 0.5;
    pointer-events: none;
}

@media screen and (min-width: 768px) {

    .daterangepicker.show-ranges.show-weeknumbers,
    .daterangepicker.show-ranges {
        min-width: 683px !important;
    }
}
</style>
